<template>
    <div>
        <el-form :model="formData" ref="formData" label-position="top" size="medium">
            <el-row :gutter="30">               
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="surveyName" label="主题：" :rules="[{ required: true, message: '请填写主题' }]">
                        <span slot="label">
                            主题：
                            <small><span class="el-icon-warning"></span> 主题会显示给用户看到</small>
                        </span>
                        <el-input placeholder="请填写主题" v-model="formData.surveyName" maxlength="40" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
			<el-row :gutter="30">
			    <el-col :xs="24" :sm="12" :xl="8">
			        <el-form-item prop="surveyDesc" label="说明:" :rules="[{ required: true, message: '请填写说明' }]">
						<span slot="label">
						    说明：
						    <small><span class="el-icon-warning"></span> 说明会显示给用户看到</small>
						</span>			           
						<el-input v-model="formData.surveyDesc" type="textarea" :rows="4" maxlength="200" show-word-limit></el-input>
			        </el-form-item>
			    </el-col>
			</el-row>
			<el-row :gutter="30">
			    <el-col :xs="24" :xl="16">
			        <el-form-item prop="rights" label="调查项：">
			            <span slot="label">调查项：<el-button  icon="el-icon-plus" size="mini" type="primary" @click="$refs.rightsEdit.show()">新增调查项</el-button></span>
						<div>
							<template v-if="formData.questionList && formData.questionList.length >0 ">
								<vuedraggable v-model="formData.questionList">
									<el-card v-for="(item,index) in formData.questionList" :key="index" class="MT10">
										<div slot="header" class="card-header">
											<div class="name">												
												<span v-if="item.questionType ==1" class="color-warning">单选</span>
												<span v-if="item.questionType ==2" class="color-success">多选</span>
												<span v-if="item.questionType ==3" class="color-info">文本</span>
												<span v-if="item.questionType ==4" class="color-danger">图片</span>
												{{item.questionName}}
											</div>
											<div class="status">												
												<el-button												    
													type="text"
													size="small"
													icon="el-icon-delete"
													@click="del(index)"
													v-if="formData.questionList && formData.questionList.length >1 "
													>删除</el-button
												>												
											</div>
										</div>
										<div v-if="item.questionType ==1 || item.questionType ==2" class="optionMain">
											<div class="optionName">问题选项：</div>
											<template v-if="item.optionList && item.optionList.length > 0">
												<div v-for="(items,indexs) in item.optionList" :key="indexs" class="options">
													<span><span class="color-info">{{items.optionName}}</span></span>							               
												</div>
												<div v-if="item.haveOther ==1">其他</div>
											</template>
										</div>										
									</el-card>
								</vuedraggable>
							</template>
							<div v-else class="center">
							    <el-empty description="暂无调查项" :image-size="100" style="width: 500px;"></el-empty>
							</div>
						</div>
			            <div class="form-tips color-info" v-if="formData.questionList && formData.questionList.length >1 "><i class="el-icon-warning"></i> 可拖动排序</div>
			        </el-form-item>
			    </el-col>
			</el-row>
			
			<el-row :gutter="30">
			    <el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="awardType" label="礼品设置:">
						<el-select v-model="formData.awardType" size="medium">
							<el-option :value="1" label="无偿参与"></el-option>
							<el-option :value="2" label="参与人发放优惠券"></el-option>
						</el-select>
						<el-input placeholder="输入优惠券ID" v-model="formData.awardId" maxlength="40" v-if="formData.awardType == 2" class="awardId"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
            <el-form-item class="MT20">                
                           
            </el-form-item>
        </el-form>
		<el-button type="primary" @click="submitForm()">确认提交</el-button>     
		<rights-edit ref="rightsEdit" :formData.sync="formData"></rights-edit>
		<!-- <rights-detail ref="rightsDetail" :formData.sync="formData"></rights-detail> -->
    </div>
</template>

<script>
import RightsEdit from "./components/RightsEdit";
// import RightsDetail from "./components/RightsDetail";
import vuedraggable from 'vuedraggable';
const defaultData = {
    surveyName:'',
    surveyDesc: '',	
	awardType:1,	
	questionList:[],
	awardId:''
	
}
export default {
    components: {RightsEdit,vuedraggable},
	props:{
	    id: {
	        type: [Number, String],
	        default: () => null
	    }
	},
    data() {
        return {        
            formData: {
               ...defaultData
            },
			
			toolbar:['fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify '],
			drawerShow:false,
			btnLoading:false,
			dataLoading:false,
			
        };
    },
    mounted() {
		
       if (this.id) {
           this.getDetailData();
       }else{
		   this.formData.questionList = []
		  
	   }	
    },
	
    methods: {
		
		del(index) {
			
		    this.$confirm('是否删除该调查项？', '删除调查项', {
		        type: 'warning',
		        center: true,
		        closeOnClickModal: false
		    }).then(async () => {
		        if( this.formData.questionList.length > 0){
		        	this.formData.questionList.forEach((tab, idx) => {					
		        	   if( index == idx){
		        		   this.formData.questionList.splice(index,1)
		        	   }
		        	})
		        	
		        }
		    })
		},
       //表单提交
       submitForm() {
		   
		   if( this.formData.surveyDesc == ''){			   
			   return this.$message.error('问卷说明不能为空！');
		   }
		   if( this.formData.questionList == ''){
				return this.$message.error('请先添加调查项！');
		   }
		   if( this.formData.awardType == 2 && this.formData.awardId =='' ){
				return this.$message.error('优惠券ID不能为空！');
		   }
			this.formData.questionList.forEach((tab, idx) => {				   
				tab.sort = idx 					
		   	})
		 
           this.$refs["formData"].validate((valid) => {
               if (valid) {
                   this.btnLoading = true;
                   this.$request({
                       url: '/survey/createOrUpdate',
                       method: "post",
                       data: {
                           ...this.formData                           
                       },
                   })
                       .then((res) => {
                           const { state, msg } = res.data;
                           if (state == 1) {
							  this.$message.success("操作成功");
                              this.goBack();
                           } else {
                               this.$message.error(msg || "操作失败,请重试");
                           }
                       })
                       .catch(() => {
                           this.$message.error("操作失败,请重试");
                       })
                       .finally(() => {
                           this.btnLoading = false;
                       });
               } else {
                   return false;
               }
           });
       },
       //返回
       goBack() {
           if (this.redirect) {
               this.$router.push({
                   path: this.redirect,
               });
           } else {
               this.$router.go(-1);
           }
		   
		   
       },	   
	   //获取详情
	   getDetailData() {
	       this.dataLoading = true;
	       this.$request({
	           url: "/survey/detail",
	           method: "POST",
	           params: {
	               id: this.id
	           },
	       })
	           .then((res) => {
	               const { state, msg, result } = res.data;
	               if (state == 1 && result) {
	                   this.formData = result
					   
	               } else {
	                   this.$message.error(msg || "请求失败");
	               }
	           })
	           .catch(() => {
	               this.$message.error("请求错误");
	           })
	           .finally(() => {
	               this.dataLoading = false;
	           });
	   },
	   
        
    },
};
</script>

<style lang="scss" scoped>
::v-deep  .el-card__body {
	padding:0
}
.optionMain{
	padding:20px
}
.awardId{
	margin-top:15px;
}
.wenanBox{
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	.el-icon-remove-outline{
		margin-left: 15px;
	}
	.wnIpt{
		width: 400px;
	}
}
.card-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
	margin:-10px 0;
    .name{
        font-size: 18px;
		span{
			display:inline-block;
			margin-right:10px;
		}
    }
	.status{
		
	}
}
.optionName{
	font-size:16px;
	color:#000;
	margin-top:-15px;
	margin-bottom:10px
}
.options{
	line-height:20px;
}
.center{
    .el-empty{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
</style>